import React, { useState } from 'react';
import lizaProfileIMG from '../../images/profileIMG/ourfounder.jpg';
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';

const About2 = (props) => {
    const [expanded, setExpanded] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    const funFact = [
        { title: '9', subTitle: 'Volunteer', Symbol: '+' },
        { title: '500', subTitle: 'Happy Children', Symbol: '+' },
        { title: '8000', subTitle: 'Donations Received', Symbol: '+' },
        { title: '5500', subTitle: 'Donated', Symbol: '+' },
        { title: '9', subTitle: 'Campaigns', Symbol: '+' },
    ];

    return (
        <section className="about-section-s2">
            <div className="container">
                <div className="row">
                    <div className="col-xl-8 col-lg-7 col-12">
                        <div className="about-area">
                            <div className="section-title">
                                <span>#OurFoundation</span>
                                <h2>Love of Hearts Foundation Incorporated</h2>
                            </div>
                            <div className="about-details">
                                At the heart of our mission is a simple yet powerful belief: everyone deserves the
                                opportunity to thrive. Born from personal experiences and a deep commitment to service,
                                Love of Hearts Foundation Incorporated was established to uplift individuals and
                                strengthen the communities we call home.
                                <br/>
                                <br/>
                                <div>
                                    We understand that life presents real challenges—whether it's financial
                                    hardship, personal setbacks, or a lack of access to vital resources. That’s
                                    why we focus on empowering individuals, protecting vulnerable populations,
                                    and investing in the next generation through education and mentorship.
                                </div>

                                {!expanded && (
                                    <button
                                        onClick={() => setExpanded(true)}
                                        style={{
                                            marginTop: '10px',
                                            color: '#007BFF',
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer',
                                            padding: 0,
                                            display: 'block'
                                        }}
                                    >
                                        Read More
                                    </button>
                                )}

                                {expanded && (
                                    <>
                                        <br/>
                                        From providing school supplies at our annual Back-to-School event to supporting
                                        aspiring leaders through scholarships and guidance, our programs are designed to
                                        make a lasting impact. We collaborate with local organizations to offer critical
                                        support, ensuring that no one faces life’s obstacles alone.
                                        <br/>
                                        <br/>
                                        Driven by our core values of integrity, respect, community, passion, and
                                        diversity, we are committed to building a future where every person has the
                                        tools and opportunities to turn their dreams into reality.
                                        <br/>
                                        <br/>
                                        Join us. Whether you give, volunteer, or share our mission, your support helps
                                        us create brighter futures—one heart at a time.
                                        <br/>
                                        <button
                                            onClick={() => setExpanded(false)}
                                            style={{
                                                marginTop: '10px',
                                                color: '#007BFF',
                                                background: 'none',
                                                border: 'none',
                                                cursor: 'pointer',
                                                padding: 0,
                                                display: 'block'
                                            }}
                                        >
                                            Read Less
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="col col-xl-4 col-lg-5 col-12">
                        <div className="fun-fact-area">
                            <div className="fun-fact-grids clearfix">
                                {funFact.map((funfact, fitem) => (
                                    <div className="grid" key={fitem}>
                                        <div className="info">
                                            <h3>
                                                <span>
                                                    <CountUp end={funfact.title} enableScrollSpy />
                                                </span>
                                                {funfact.Symbol}
                                            </h3>
                                            <p>{funfact.subTitle}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <hr className="my-8 border-gray-300" />

                <div className="row">
                    <div className="col-xl-8 col-lg-7 col-12">
                        <div className="about-area">
                            <div className="section-title">
                                <span>#OurFounder</span>
                                <h2>Meet Liza!!!</h2>
                            </div>
                            <div className="about-details">
                                Liza is a Family Nurse Practitioner and founder of Love of Hearts Foundation
                                Incorporated, that serves students, people in crisis, and abuse survivors. With Christ
                                as her foundation, she empowers individuals to reclaim their lives through education,
                                compassion, and support. A mother of three and grandmother of one, she finds joy in
                                family, fitness, and purposeful living. Her mission is to be a vessel of God’s love —
                                restoring hope and creating lasting change in communities through service and grace.
                            </div>
                            <Link onClick={ClickHandler} to="/team-single/Liza-Hart" className="theme-btn-s4">
                                More about LIZA
                            </Link>
                        </div>
                    </div>
                    <div className="col col-xl-4 col-lg-5 col-12">
                        <img src={lizaProfileIMG} alt="Liza Hart" />
                    </div>
                </div>

                <hr className="my-8 border-gray-300" />
            </div>
        </section>
    );
};

export default About2;
